import { render, staticRenderFns } from "./OperatorDistributionAbsences.vue?vue&type=template&id=084c76cd&scoped=true"
import script from "./OperatorDistributionAbsences.vue?vue&type=script&lang=ts"
export * from "./OperatorDistributionAbsences.vue?vue&type=script&lang=ts"
import style0 from "./OperatorDistributionAbsences.vue?vue&type=style&index=0&id=084c76cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c76cd",
  null
  
)

export default component.exports